import React, { useMemo } from 'react';
import { SVGIcon } from '../SVGIcon/SVGIcon';
import clsx from 'clsx';
import { IconColor, IconName, IconSize } from '../SVGIcon/SVGIcon.types';
import useWindowSize from '@/hooks/use-window-size';

export type StepNumber = 1 | 2 | 3 | 4 | 5;
export interface StepIconProps {
  currentStep: number;
  step: StepNumber;
}

interface StepIconConfig {
  name: IconName;
  size: IconSize;
  fill: IconColor | string;
}

export const StepIcon: React.FC<StepIconProps> = ({ currentStep, step }) => {
  const { isMobile } = useWindowSize();

  const iconConfig = useMemo((): StepIconConfig => {
    if (isMobile) {
      if (step < currentStep) {
        return { name: 'check', size: 'sm', fill: 'white' };
      }
      if (step === currentStep) {
        return { name: 'loading-dots', size: 20, fill: 'white' };
      }
      return { name: 'clock-2', size: 20, fill: 'text-secondary' };
    }

    return {
      name: `step${step}` as IconName,
      size: 'timeline' as IconSize,
      fill: step < currentStep
        ? 'white'
        : step === currentStep
          ? 'white'
          : 'text-secondary',
    };
  }, [isMobile, step, currentStep]);

  return (
    <div
      className={clsx(
        'flex h-[40px] min-h-[40px] w-[40px] min-w-[40px] items-center justify-center gap-[10px] rounded-[100px] border-[4px] p-[4px] md:h-[76px] md:min-h-[76px] md:w-[76px] md:min-w-[76px]',
        step < currentStep
          ? 'border-greenLight bg-green'
          : step === currentStep
            ? 'border-blueLight bg-blue'
            : 'border-gray-100 bg-gray-300',
      )}
      role="img"
      aria-label={`Krok ${step}`}
    >
      <div className="flex justify-center items-center w-full h-full text-white rounded-full">
        <SVGIcon
          name={iconConfig.name}
          size={iconConfig.size}
          fill={iconConfig.fill}
        />
      </div>
    </div>
  );
};
